import {h, Fragment} from "preact"
import { RangeSlider, useRangeSlider } from "@nosto/preact"
import { useState } from "preact/hooks"
import RangeInput from "./elements/RangeInput"

export default function RangeFacet({ facet }) {
    const { min, max, range, updateRange } = useRangeSlider(facet.id)
    const isSelected = min !== range[0] || max !== range[1]
    const [active, setActive] = useState(isSelected)

    return (
        <li class={`ns-sidebar-dropdown ${active ? "ns-active" : ""}`}>
            <span
                class="ns-anchor ns-d-inline-block ns-relative ns-w-100 ns-border-box pb-1.5 border-b border-t-brand-accent-01 cursor-pointer"
                onClick={() => {
                    setActive(!active)
                }}
            >
                <span class="h6 font-medium tracking-[0.16em] text-t-brand-foreground-secondary">{facet.name}</span>
                {/* {isSelected && (
                    <span class="ns-total-count ns-d-inline-block ns-text-align-center ns-font-3 ns-font-bold ns-color-white ns-background-primary ns-ml-1">
                        {1}
                    </span>
                )} */}
                <svg width="10" height="10" aria-hidden='true' focusable='false' role='presentation' viewBox='0 0 10 10' fill='none'>
                    <path d="M9.58337 2.9165L5.00004 6.92692L0.416707 2.9165" stroke="currentColor" stroke-width="0.666667"/>
                </svg>
            </span>
            <div class="ns-sidebar-submenu ns-d-none ns-p-4">
                <div class="ns-d-flex ns-justify-content-between ns-font-4">
                    <div class="ns-col-6 flex-shrink-1 ns-mr-2">
                        <label for={`ns-${facet.id}-min`} class="ns-form-label">
                            Min.
                        </label>
                        <RangeInput
                            id={`ns-${facet.id}-min`}
                            min={min}
                            max={max}
                            range={range}
                            value={range[0]}
                            onChange={e => {
                                const value = parseFloat(e.currentTarget.value) || undefined
                                updateRange([value, range[1]])
                            }}
                        />
                    </div>
                    <div class="ns-col-6 flex-shrink-1">
                        <label for={`ns-${facet.id}-max`} class="ns-form-label">
                            Max.
                        </label>
                        <RangeInput
                            id={`ns-${facet.id}-max`}
                            min={min}
                            max={max}
                            range={range}
                            value={range[1]}
                            onChange={e => {
                                const value = parseFloat(e.currentTarget.value) || undefined
                                updateRange([range[0], value])
                            }}
                        />
                    </div>
                </div>
                <RangeSlider id={facet.id} />
            </div>
        </li>
    )
}
